export const dashCase = (inputString) => {
  return inputString.toLowerCase().replace(/ /g, "-");
};

export const shortUrl = (fullUrl) => {
  var url = fullUrl;
  try {
    const urlObject = new URL(url);
    url = urlObject.pathname ? urlObject.pathname : url;
  } catch (error) {
    url = fullUrl;
  }
  return url;
};

export function toggleAccordion(element, selector, activeClass = "active") {
  if (typeof document !== "undefined") {
    const target = element.querySelector(selector);
    const allElements = document.querySelectorAll(selector);

    allElements.forEach((el) => {
      if (el !== target) {
        el.style.maxHeight = null;
        el.parentElement.classList.remove(activeClass);
      }
    });

    if (target && target.style.maxHeight) {
      target.style.maxHeight = null;
      element.classList.remove(activeClass);
    } else {
      if (target) {
        target.style.maxHeight = target.scrollHeight + "px";
        element.classList.add(activeClass);
      }
    }
  }
}

export const DateFormat = (dateStr) => {
  const date = new Date(dateStr);

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  const ordinalSuffix = getOrdinalSuffix(day);
  const formattedDate = `${day}${ordinalSuffix} ${month} ${year}`;

  return formattedDate;
};

export const removeTags = (str) => {
  if (str === null || str === "") return false;
  else str = str.toString();
  return str.replace(/(<([^>]+)>)/gi, "");
};

export const getFileName = (url) => {
  try {
    const pathParts = url.split("/");

    let fileName = pathParts[pathParts.length - 1]; // Get the last part of the path

    if (!fileName) {
      console.error("No file name found in the URL");
      return null;
    }

    // Truncate if file name is too long
    const maxLength = 15;
    if (fileName.length > maxLength) {
      const prefixLength = 10; // Length of the starting part
      const suffixLength = 4; // Length of the ending part
      fileName = `${fileName.slice(0, prefixLength)}...${fileName.slice(
        -suffixLength
      )}`;
    }

    return fileName;
  } catch (error) {
    console.error("Invalid URL:", error.message);
    return null;
  }
};

export const formatStepErrors = (errors) => {
  const messages = [];

  for (const [step, fields] of Object.entries(errors)) {
    const fieldNames = Object.keys(fields).join(", ");
    messages.push(
      `In ${step.replace("-", " ")}, the field(s) "${fieldNames}" are required.`
    );
  }

  return messages.join(" ");
};

export function convertDirToUrl(path) {
  
  if (!path) return;
  if(typeof path === "boolean"){
    path = path.toString;
  }
  
  const fileExtensions = [
    ".tiff",
    ".tif",
    ".bmp",
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".pdf",
    ".docx",
    ".xlsx",
  ];
  if (typeof path !== "function" && path.includes("wp-content")) {
    const isFile = fileExtensions.some((ext) => path.endsWith(ext));
    if (isFile) {
      const filePath = path.replace(/^.*\/wp-content/, "/wp-content");
      return `https://wp.orientfinance.com${filePath}`;
    }
  }
  return path;
}


export const flattenedArray = (inputArray) => {
  return inputArray.flatMap((item) => { 
    if (item.includes(",")) {
      return item.split(",").map((subItem) => subItem.trim()); 
    } else {
      return item; 
    }
  });
};